export default {
    displayGroupsColumnInUsersTable (){
        return false;
    },
    currentSearchTerm: (state) => {
        return state.searchTerm;
    },
    displayChooseEntityFullOverlay(){
        // DO NOT DISPLAY view Choose Entity
        return false;
    },
    displayAppSearchBar (){
        return false;
    },
    displayAuthFullOverlay(state, getters, rootState, rootGetters){
        return !rootGetters.userIsAuthenticated;
    },

    displayLoadingFullOverlay(state, getters, rootState, rootGetters){
        return !rootGetters.modelsUnscopedLoaded;
    },
    enableGroupsAdministration(){
        return false;
    },
    enableUsersAdministration(){
        return true;
    },
    enablePermissionAdministration(){
        return false;
    },
    enableGroupsSideBarMenu(){
        return false;
    },
    enableUsersSideBarMenu(state){
        return !state.useApiValoAuth;
    },
    enableDownloadCsvGroups(){
        return false;
    },
    enableDownloadCsvUsers(){
        return false;
    },
    enableRegister(){
        return false;
    },
    enableResetPassword(){
        return true;
    },
    enableSidebarCollapse(){
        return false;
    },
    enableLoginByEmail(){
        return false;
    },
    enableCreateUser(){
        return true;
    },
    enableCreateGroup(){
        return false;
    },
    enableDeleteGroup() {
        return true;
    },
    enableManageNotifications() {
        return false;
    },
    enableManageOtherUsersNotifications() {
        return false;
    },
    sidebarName() {
        return 'Viveco facturation';
    },
    logoFile() {
        return '/static/img/big_logo.png';
    },
    backgroundFile1() {
        return '/static/img/background_file_1.jpg';
    },
    backgroundFile2() {
        return '/static/img/static_img_viveco.jpg';
    },
    logoFileTopHeader() {
        return '/static/img/Viveco_Facturation.svg';
    },
    loginImage() {
        return '/static/img/viveco-footer.jpg';
    },
    userExtraEditableFields(){
        return {
            first_name: 'Prénom',
            last_name: 'Nom',
            password1: 'Mot de passe',
            password2: 'Confirmation du mot de passe',
            company_name: 'Entreprise'
        };
    },
    userExtraEditableFieldsOptions(){
        return {
            first_name: { type: 'string' },
            last_name: { type: 'string' },
            company_name: {
                type: 'string',
                displayColumn: true,
                keyVerbose: 'Entreprise',
                getVerbose: (value) => value,
            },
        };
    },
    displaySidebarHorizontalsButtons(){
        return false;
    },
    useApiValo(state){
        return state.useApiValoAuth;
    },
    enableUnblockUser(){
        return false;
    },
    displayFirstLastNameColumnInUsersTable(){
        return true;
    },
    shouldFetchModelAclRoles (){
        return false;
    },
    shouldFetchModelAclPermissions (){
        return false;
    },

};



// WEBPACK FOOTER //
// ./src/store/getters.js